import {
  END_SLACK_FETCH,
  START_SLACK_FETCH,
  UPDATE_SLACK_INFO,
} from '../constants/actions';

const DEFAULT_SLACK_STATE = {
  team_info: null,
  fetching: false,
  first_fetch_done: false,
  users_on_loom: [], // list of Slack team member IDs that are Loom users
  invite_modal_source: null,
};

const slackReducer = (state = DEFAULT_SLACK_STATE, action) => {
  switch (action.type) {
    case UPDATE_SLACK_INFO:
      return {
        ...state,
        team_info: action.team_info,
      };
    case START_SLACK_FETCH:
      return {
        ...state,
        fetching: true,
      };
    case END_SLACK_FETCH:
      return {
        ...state,
        fetching: false,
        first_fetch_done: true,
      };
    default:
      return state;
  }
};

export default slackReducer;
